var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-card",
        { staticClass: "left-box" },
        [
          _c("el-card", { staticClass: "topInfo" }, [
            _c(
              "div",
              { staticClass: "wh100 df" },
              [
                _c(
                  "el-card",
                  {
                    staticStyle: { width: "25%", height: "100%" },
                    attrs: { shadow: "never" },
                  },
                  [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.ProjectLoading,
                            expression: "ProjectLoading",
                          },
                        ],
                        staticClass: "cellInfo",
                      },
                      [
                        _c("div", { staticClass: "cellInfo-title" }, [
                          _c(
                            "div",
                            {
                              staticClass: "ellipsis",
                              staticStyle: {
                                width: "calc(100% - 80px)",
                                color: "#606266",
                              },
                            },
                            [_vm._v(" 项目信息 ")]
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                width: "80px",
                                display: "flex",
                                "justify-content": "center",
                              },
                            },
                            [
                              _vm.ProjectInfo.ProjectStatus == 0
                                ? _c(
                                    "el-tag",
                                    {
                                      staticStyle: { "text-align": "center" },
                                      attrs: { size: "medium" },
                                    },
                                    [_vm._v("新建")]
                                  )
                                : _vm._e(),
                              _vm.ProjectInfo.ProjectStatus == 1
                                ? _c(
                                    "el-tag",
                                    {
                                      staticStyle: { "text-align": "center" },
                                      attrs: {
                                        type: "warning",
                                        size: "medium",
                                      },
                                    },
                                    [_vm._v("进行中")]
                                  )
                                : _vm._e(),
                              _vm.ProjectInfo.ProjectStatus == 2
                                ? _c(
                                    "el-tag",
                                    {
                                      staticStyle: { "text-align": "center" },
                                      attrs: {
                                        type: "success",
                                        size: "medium",
                                      },
                                    },
                                    [_vm._v("完成")]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]),
                        _c(
                          "div",
                          { staticClass: "df" },
                          [
                            _c("el-image", {
                              staticStyle: {
                                width: "140px",
                                height: "140px",
                                "border-radius": "20px",
                              },
                              attrs: {
                                src: _vm.ProjectInfo.ProjectImg,
                                fit: "cover",
                              },
                            }),
                            _c("div", { staticClass: "cellInfo-content" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "projectText ellipsis",
                                  staticStyle: { width: "100%" },
                                  attrs: { title: _vm.ProjectInfo.Name },
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.ProjectInfo.Name) + " "
                                  ),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "projectText ellipsis",
                                  staticStyle: { width: "100%" },
                                  attrs: { title: _vm.ProjectInfo.Code },
                                },
                                [
                                  _vm._v(
                                    " 项目编号：" +
                                      _vm._s(_vm.ProjectInfo.Code) +
                                      " "
                                  ),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "projectText ellipsis",
                                  staticStyle: { width: "100%" },
                                  attrs: { title: _vm.ProjectInfo.TotalArea },
                                },
                                [
                                  _vm._v(
                                    " 建筑面积：" +
                                      _vm._s(_vm.ProjectInfo.TotalArea) +
                                      " "
                                  ),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "projectText ellipsis",
                                  staticStyle: { width: "100%" },
                                  attrs: { title: _vm.ProjectInfo.TotalFloor },
                                },
                                [
                                  _vm._v(
                                    " 位置：" +
                                      _vm._s(_vm.ProjectInfo.Province) +
                                      " " +
                                      _vm._s(_vm.ProjectInfo.City) +
                                      " "
                                  ),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "projectText ellipsis",
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    title: _vm.ProjectInfo.OpeningTime
                                      ? _vm
                                          .moment(_vm.ProjectInfo.OpeningTime)
                                          .format("YYYY年MM月DD日")
                                      : "",
                                  },
                                },
                                [
                                  _vm._v(
                                    " 开工：" +
                                      _vm._s(
                                        _vm.ProjectInfo.OpeningTime
                                          ? _vm
                                              .moment(
                                                _vm.ProjectInfo.OpeningTime
                                              )
                                              .format("YYYY年MM月DD日")
                                          : ""
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "projectText ellipsis",
                                  staticStyle: { width: "100%" },
                                  attrs: { title: _vm.ProjectInfo.Creator },
                                },
                                [
                                  _vm._v(
                                    " 项目经理：" +
                                      _vm._s(_vm.ProjectInfo.Creator) +
                                      " "
                                  ),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "projectText ellipsis",
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    title: _vm.ProjectInfo.Property_Company,
                                  },
                                },
                                [
                                  _vm._v(
                                    " 物业单位：" +
                                      _vm._s(_vm.ProjectInfo.Property_Company) +
                                      " "
                                  ),
                                ]
                              ),
                            ]),
                          ],
                          1
                        ),
                      ]
                    ),
                  ]
                ),
                _c(
                  "el-card",
                  {
                    staticStyle: { width: "400px", height: "100%" },
                    attrs: { shadow: "never" },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "wh100",
                        staticStyle: { display: "flex" },
                      },
                      [
                        _c("el-card", { staticClass: "ButInfo" }, [
                          _c(
                            "div",
                            {
                              staticClass: "ButInfo-content",
                              on: {
                                click: function ($event) {
                                  return _vm.toDomRouter("File")
                                },
                              },
                            },
                            [
                              _c("div", [
                                _c("div", { staticClass: "icon" }, [
                                  _c("i", {
                                    staticClass: "icon-yunpan icon",
                                    staticStyle: { color: "#70babf" },
                                  }),
                                ]),
                                _c(
                                  "div",
                                  {
                                    staticClass: "text",
                                    staticStyle: { color: "#70babf" },
                                  },
                                  [_vm._v("项目云盘")]
                                ),
                              ]),
                            ]
                          ),
                        ]),
                        _c("el-card", { staticClass: "ButInfo" }, [
                          _c(
                            "div",
                            {
                              staticClass: "ButInfo-content",
                              on: {
                                click: function ($event) {
                                  return _vm.toDomRouter("ProjectOverview")
                                },
                              },
                            },
                            [
                              _c("div", [
                                _c("div", { staticClass: "icon" }, [
                                  _c("i", {
                                    staticClass: "icon-analyticsprogram icon",
                                    staticStyle: { color: "#67c23a" },
                                  }),
                                ]),
                                _c(
                                  "div",
                                  {
                                    staticClass: "text",
                                    staticStyle: { color: "#67c23a" },
                                  },
                                  [_vm._v("项目统计")]
                                ),
                              ]),
                            ]
                          ),
                        ]),
                      ],
                      1
                    ),
                  ]
                ),
                _c(
                  "el-card",
                  {
                    staticStyle: { width: "calc(75% - 400px)", height: "100%" },
                    attrs: { shadow: "never" },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "wh100",
                        staticStyle: {
                          display: "flex",
                          "align-items": "center",
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "Buttop" },
                          [
                            _c(
                              "el-card",
                              {
                                staticStyle: { width: "25%", height: "100%" },
                                attrs: { shadow: "never" },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "wh100 info-Buttop",
                                    staticStyle: { padding: "0px 10px" },
                                  },
                                  [
                                    _c("div", { staticClass: "w100" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "rightNum",
                                          staticStyle: { color: "#e6a23c" },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "w100 tac" },
                                            [
                                              _c("i", {
                                                staticClass: "icon-shebei icon",
                                                staticStyle: {
                                                  color: "#e6a23c",
                                                  "font-size": "24px",
                                                },
                                              }),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "w100 tac" },
                                            [_vm._v("设备")]
                                          ),
                                        ]
                                      ),
                                      _c("div", { staticClass: "leftNum" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "ellipsis num w100 tac",
                                            attrs: {
                                              title: `${Math.round(
                                                Number(
                                                  _vm.dataStatistics
                                                    .DeviceSubQty || 0
                                                )
                                              )}/${Math.round(
                                                Number(
                                                  _vm.dataStatistics
                                                    .DeviceQty || 0
                                                )
                                              )}`,
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  "font-size": "18px",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    Math.round(
                                                      Number(
                                                        _vm.dataStatistics
                                                          .DeviceSubQty || 0
                                                      )
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                            _vm._v(
                                              "/" +
                                                _vm._s(
                                                  Math.round(
                                                    Number(
                                                      _vm.dataStatistics
                                                        .DeviceQty || 0
                                                    )
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _c("div", { staticClass: "w100 tac" }, [
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                "font-size": "12px",
                                              },
                                            },
                                            [_vm._v("提交数/总数")]
                                          ),
                                        ]),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]
                            ),
                            _c(
                              "el-card",
                              {
                                staticStyle: { width: "25%", height: "100%" },
                                attrs: { shadow: "never" },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "wh100 info-Buttop",
                                    staticStyle: { padding: "0px 10px" },
                                  },
                                  [
                                    _c("div", { staticClass: "w100" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "rightNum",
                                          staticStyle: { color: "#bfa170" },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "w100 tac" },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "icon-gongyingshang1 icon",
                                                staticStyle: {
                                                  "font-size": "24px",
                                                },
                                              }),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "w100 tac" },
                                            [_vm._v("供应商")]
                                          ),
                                        ]
                                      ),
                                      _c("div", { staticClass: "leftNum" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "ellipsis num w100 tac",
                                            attrs: {
                                              title: `${Math.round(
                                                Number(
                                                  _vm.dataStatistics
                                                    .SupplierSubQty || 0
                                                )
                                              )}/${Math.round(
                                                Number(
                                                  _vm.dataStatistics
                                                    .SupplierQty || 0
                                                )
                                              )}`,
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  "font-size": "18px",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    Math.round(
                                                      Number(
                                                        _vm.dataStatistics
                                                          .SupplierSubQty || 0
                                                      )
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                            _vm._v(
                                              "/" +
                                                _vm._s(
                                                  Math.round(
                                                    Number(
                                                      _vm.dataStatistics
                                                        .SupplierQty || 0
                                                    )
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _c("div", { staticClass: "w100 tac" }, [
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                "font-size": "12px",
                                              },
                                            },
                                            [_vm._v("提交数/总数")]
                                          ),
                                        ]),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]
                            ),
                            _c(
                              "el-card",
                              {
                                staticStyle: { width: "25%", height: "100%" },
                                attrs: { shadow: "never" },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "wh100 info-Buttop",
                                    staticStyle: { padding: "0px 10px" },
                                  },
                                  [
                                    _c("div", { staticClass: "w100" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "rightNum",
                                          staticStyle: { color: "#409eff" },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "w100 tac" },
                                            [
                                              _c("i", {
                                                staticClass: "el-icon-tickets",
                                                staticStyle: {
                                                  "font-size": "24px",
                                                },
                                              }),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "w100 tac" },
                                            [_vm._v("资料")]
                                          ),
                                        ]
                                      ),
                                      _c("div", { staticClass: "leftNum" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "ellipsis num w100 tac",
                                            attrs: {
                                              title: `${Math.round(
                                                Number(
                                                  _vm.dataStatistics
                                                    .DataSubData || 0
                                                )
                                              )}/${Math.round(
                                                Number(
                                                  _vm.dataStatistics.DataQty ||
                                                    0
                                                )
                                              )}`,
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  "font-size": "18px",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    Math.round(
                                                      Number(
                                                        _vm.dataStatistics
                                                          .DataSubData || 0
                                                      )
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                            _vm._v(
                                              "/" +
                                                _vm._s(
                                                  Math.round(
                                                    Number(
                                                      _vm.dataStatistics
                                                        .DataQty || 0
                                                    )
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _c("div", { staticClass: "w100 tac" }, [
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                "font-size": "12px",
                                              },
                                            },
                                            [_vm._v("提交数/总数")]
                                          ),
                                        ]),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]
                            ),
                            _c(
                              "el-card",
                              {
                                staticStyle: { width: "25%", height: "100%" },
                                attrs: { shadow: "never" },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "wh100 info-Buttop",
                                    staticStyle: { padding: "0px 10px" },
                                  },
                                  [
                                    _c("div", { staticClass: "w100" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "rightNum",
                                          staticStyle: { color: "#6bc1c1" },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "w100 tac" },
                                            [
                                              _c("i", {
                                                staticClass: "el-icon-menu",
                                                staticStyle: {
                                                  "font-size": "24px",
                                                },
                                              }),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "w100 tac" },
                                            [_vm._v("备件")]
                                          ),
                                        ]
                                      ),
                                      _c("div", { staticClass: "leftNum" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "ellipsis num w100 tac",
                                            attrs: {
                                              title: `${Math.round(
                                                Number(
                                                  _vm.dataStatistics
                                                    .SparePartsSubQty || 0
                                                )
                                              )}/${Math.round(
                                                Number(
                                                  _vm.dataStatistics
                                                    .SparePartsQty || 0
                                                )
                                              )}`,
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  "font-size": "18px",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    Math.round(
                                                      Number(
                                                        _vm.dataStatistics
                                                          .SparePartsSubQty || 0
                                                      )
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                            _vm._v(
                                              "/" +
                                                _vm._s(
                                                  Math.round(
                                                    Number(
                                                      _vm.dataStatistics
                                                        .SparePartsQty || 0
                                                    )
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _c("div", { staticClass: "w100 tac" }, [
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                "font-size": "12px",
                                              },
                                            },
                                            [_vm._v("提交数/总数")]
                                          ),
                                        ]),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
          _c(
            "el-card",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading1,
                  expression: "loading1",
                },
              ],
              staticStyle: {
                height: "calc(100% - 310px)",
                width: "100%",
                "margin-top": "10px",
                padding: "0px 10px",
              },
            },
            [
              _c(
                "el-tabs",
                {
                  staticStyle: { height: "100%" },
                  on: { "tab-click": _vm.changeTableData },
                  model: {
                    value: _vm.tabswait,
                    callback: function ($$v) {
                      _vm.tabswait = $$v
                    },
                    expression: "tabswait",
                  },
                },
                [
                  _c(
                    "el-tab-pane",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.loading2,
                          expression: "loading2",
                        },
                      ],
                      attrs: { label: "已审核", name: "tg" },
                    },
                    [
                      _c(
                        "el-table",
                        {
                          ref: "passTable",
                          attrs: {
                            data: _vm.passData,
                            height: "calc(100% - 40px)",
                          },
                          on: { "row-click": _vm.handleClick },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              type: "index",
                              label: "序号",
                              width: "55",
                              align: "center",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "设备编号",
                              prop: "device_no",
                              align: "center",
                              sortable: "",
                              "show-overflow-tooltip": "",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "设备名称",
                              prop: "device_name",
                              align: "center",
                              sortable: "",
                              "show-overflow-tooltip": "",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "设备规格",
                              prop: "specification",
                              align: "center",
                              sortable: "",
                              "show-overflow-tooltip": "",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "设备数量",
                              prop: "Num",
                              align: "center",
                              sortable: "",
                              "show-overflow-tooltip": "",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "安装日期",
                              prop: "purchase_date",
                              align: "center",
                              sortable: "",
                              "show-overflow-tooltip": "",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "填写人",
                              prop: "cVenName",
                              align: "center",
                              sortable: "",
                              "show-overflow-tooltip": "",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "生产厂家名称",
                              prop: "manufacturer",
                              align: "center",
                              sortable: "",
                              "show-overflow-tooltip": "",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "维修商名称",
                              prop: "maintenance",
                              align: "center",
                              sortable: "",
                              "show-overflow-tooltip": "",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "提交日期",
                              prop: "SubmitTime",
                              width: "130",
                              align: "center",
                              sortable: "",
                              "show-overflow-tooltip": "",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm
                                            .moment(scope.row.SubmitTime)
                                            .format("YYYY-MM-DD HH:mm")
                                        ) +
                                        " "
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "Status",
                              label: "状态",
                              align: "center",
                              width: "130",
                              sortable: "",
                              "show-overflow-tooltip": "",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    scope.row.Status == 1
                                      ? _c(
                                          "el-tag",
                                          { attrs: { type: "warning" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                scope.row.Reviewer?.length == 1
                                                  ? "部分审核"
                                                  : "待审核"
                                              ) + " "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    scope.row.Status == 2 ||
                                    scope.row.Status == 3
                                      ? _c(
                                          "el-tag",
                                          { attrs: { type: "success" } },
                                          [_vm._v("已审核 ")]
                                        )
                                      : _vm._e(),
                                    scope.row.Status == 4
                                      ? _c(
                                          "el-tag",
                                          { attrs: { type: "danger" } },
                                          [_vm._v("驳回 ")]
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "审核人",
                              prop: "Reviewer",
                              width: "130",
                              align: "center",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return _vm._l(
                                    scope.row.Reviewer,
                                    function (item) {
                                      return _c("el-tag", { key: item }, [
                                        _vm._v(_vm._s(item)),
                                      ])
                                    }
                                  )
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "text-align": "right",
                            height: "40px",
                            display: "flex",
                            "align-items": "center",
                            "justify-content": "right",
                          },
                        },
                        [
                          _c("el-pagination", {
                            attrs: {
                              "current-page": _vm.passpagination.PageIndex,
                              "page-sizes": _vm.passpagination.PageSizes,
                              "page-size": _vm.passpagination.PageRows,
                              layout: "total, sizes, prev, pager, next, jumper",
                              total: _vm.passpagination.total,
                            },
                            on: {
                              "size-change": _vm.passhandleSizeChange,
                              "current-change": _vm.passhandleCurrentChange,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-tab-pane",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.loading1,
                          expression: "loading1",
                        },
                      ],
                      attrs: { label: "待审核列表", name: "wait" },
                    },
                    [
                      _c(
                        "el-table",
                        {
                          ref: "waitTable",
                          attrs: {
                            data: _vm.tableData,
                            height: "calc(100% - 40px)",
                          },
                          on: { "row-click": _vm.handleClick },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              type: "index",
                              label: "序号",
                              width: "55",
                              align: "center",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "设备编号",
                              prop: "device_no",
                              align: "center",
                              sortable: "",
                              "show-overflow-tooltip": "",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "设备名称",
                              prop: "device_name",
                              align: "center",
                              sortable: "",
                              "show-overflow-tooltip": "",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "设备规格",
                              prop: "specification",
                              align: "center",
                              sortable: "",
                              "show-overflow-tooltip": "",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "设备数量",
                              prop: "Num",
                              align: "center",
                              sortable: "",
                              "show-overflow-tooltip": "",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "安装日期",
                              prop: "purchase_date",
                              align: "center",
                              sortable: "",
                              "show-overflow-tooltip": "",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "供应商",
                              prop: "cVenName",
                              align: "center",
                              sortable: "",
                              "show-overflow-tooltip": "",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "生产厂家名称",
                              prop: "manufacturer",
                              align: "center",
                              sortable: "",
                              "show-overflow-tooltip": "",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "维修商名称",
                              prop: "maintenance",
                              align: "center",
                              sortable: "",
                              "show-overflow-tooltip": "",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "提交人",
                              prop: "SubmitUserName",
                              align: "center",
                              sortable: "",
                              "show-overflow-tooltip": "",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "提交日期",
                              prop: "SubmitTime",
                              width: "130",
                              align: "center",
                              sortable: "",
                              "show-overflow-tooltip": "",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm
                                            .moment(scope.row.SubmitTime)
                                            .format("YYYY-MM-DD HH:mm")
                                        ) +
                                        " "
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "Status",
                              label: "状态",
                              align: "center",
                              width: "130",
                              sortable: "",
                              "show-overflow-tooltip": "",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    scope.row.Status == 1
                                      ? _c(
                                          "el-tag",
                                          { attrs: { type: "warning" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                scope.row.Reviewer?.length == 1
                                                  ? "部分审核"
                                                  : "待审核"
                                              ) + " "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    scope.row.Status == 2 ||
                                    scope.row.Status == 3
                                      ? _c(
                                          "el-tag",
                                          { attrs: { type: "success" } },
                                          [_vm._v("已审核 ")]
                                        )
                                      : _vm._e(),
                                    scope.row.Status == 4
                                      ? _c(
                                          "el-tag",
                                          { attrs: { type: "danger" } },
                                          [_vm._v("驳回 ")]
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "审核人",
                              prop: "Reviewer",
                              width: "130",
                              align: "center",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return _vm._l(
                                    scope.row.Reviewer,
                                    function (item) {
                                      return _c("el-tag", { key: item }, [
                                        _vm._v(_vm._s(item)),
                                      ])
                                    }
                                  )
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "text-align": "right",
                            height: "40px",
                            display: "flex",
                            "align-items": "center",
                            "justify-content": "right",
                          },
                        },
                        [
                          _c("el-pagination", {
                            attrs: {
                              "current-page": _vm.pagination.PageIndex,
                              "page-sizes": _vm.pagination.PageSizes,
                              "page-size": _vm.pagination.PageRows,
                              layout: "total, sizes, prev, pager, next, jumper",
                              total: _vm.pagination.total,
                            },
                            on: {
                              "size-change": _vm.handleSizeChange,
                              "current-change": _vm.handleCurrentChange,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-tab-pane",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.loading3,
                          expression: "loading3",
                        },
                      ],
                      attrs: { label: "已驳回", name: "bh" },
                    },
                    [
                      _c(
                        "el-table",
                        {
                          ref: "rejectTable",
                          attrs: {
                            data: _vm.rejectData,
                            height: "calc(100% - 40px)",
                          },
                          on: { "row-click": _vm.handleClick },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              type: "index",
                              label: "序号",
                              width: "55",
                              align: "center",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "设备编号",
                              prop: "device_no",
                              align: "center",
                              sortable: "",
                              "show-overflow-tooltip": "",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "设备名称",
                              prop: "device_name",
                              align: "center",
                              sortable: "",
                              "show-overflow-tooltip": "",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "设备规格",
                              prop: "specification",
                              align: "center",
                              sortable: "",
                              "show-overflow-tooltip": "",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "设备数量",
                              prop: "Num",
                              align: "center",
                              sortable: "",
                              "show-overflow-tooltip": "",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "安装日期",
                              prop: "purchase_date",
                              align: "center",
                              sortable: "",
                              "show-overflow-tooltip": "",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "供应商",
                              prop: "cVenName",
                              align: "center",
                              sortable: "",
                              "show-overflow-tooltip": "",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "生产厂家名称",
                              prop: "manufacturer",
                              align: "center",
                              sortable: "",
                              "show-overflow-tooltip": "",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "维修商名称",
                              prop: "maintenance",
                              align: "center",
                              sortable: "",
                              "show-overflow-tooltip": "",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "提交人",
                              prop: "SubmitUserName",
                              align: "center",
                              sortable: "",
                              "show-overflow-tooltip": "",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "提交日期",
                              prop: "SubmitTime",
                              width: "130",
                              align: "center",
                              sortable: "",
                              "show-overflow-tooltip": "",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm
                                            .moment(scope.row.SubmitTime)
                                            .format("YYYY-MM-DD HH:mm")
                                        ) +
                                        " "
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "Status",
                              label: "状态",
                              align: "center",
                              width: "130",
                              sortable: "",
                              "show-overflow-tooltip": "",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    scope.row.Status == 1
                                      ? _c(
                                          "el-tag",
                                          { attrs: { type: "warning" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                scope.row.Reviewer?.length == 1
                                                  ? "部分审核"
                                                  : "待审核"
                                              ) + " "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    scope.row.Status == 2 ||
                                    scope.row.Status == 3
                                      ? _c(
                                          "el-tag",
                                          { attrs: { type: "success" } },
                                          [_vm._v("已审核 ")]
                                        )
                                      : _vm._e(),
                                    scope.row.Status == 4
                                      ? _c(
                                          "el-tag",
                                          { attrs: { type: "danger" } },
                                          [_vm._v("驳回 ")]
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "审核人",
                              prop: "Reviewer",
                              width: "130",
                              align: "center",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return _vm._l(
                                    scope.row.Reviewer,
                                    function (item) {
                                      return _c("el-tag", { key: item }, [
                                        _vm._v(_vm._s(item)),
                                      ])
                                    }
                                  )
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "text-align": "right",
                            height: "40px",
                            display: "flex",
                            "align-items": "center",
                            "justify-content": "right",
                          },
                        },
                        [
                          _c("el-pagination", {
                            attrs: {
                              "current-page": _vm.rejectpagination.PageIndex,
                              "page-sizes": _vm.rejectpagination.PageSizes,
                              "page-size": _vm.rejectpagination.PageRows,
                              layout: "total, sizes, prev, pager, next, jumper",
                              total: _vm.rejectpagination.total,
                            },
                            on: {
                              "size-change": _vm.rejecthandleSizeChange,
                              "current-change": _vm.rejecthandleCurrentChange,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-card",
            {
              staticStyle: {
                width: "100%",
                height: "300px",
                "margin-top": "10px",
                "box-sizing": "border-box",
                padding: "0px 10px",
              },
            },
            [
              _c(
                "el-tabs",
                {
                  staticStyle: { height: "100%" },
                  model: {
                    value: _vm.tabsStatistics,
                    callback: function ($$v) {
                      _vm.tabsStatistics = $$v
                    },
                    expression: "tabsStatistics",
                  },
                },
                [
                  _c(
                    "el-tab-pane",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.ProjectCountLoading,
                          expression: "ProjectCountLoading",
                        },
                      ],
                      staticStyle: { height: "100%" },
                      attrs: { label: "工作统计", name: "Statistics" },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            width: "100%",
                            height: "calc(100% - 10px)",
                            "box-sizing": "border-box",
                          },
                        },
                        [
                          _c(
                            "el-row",
                            {
                              staticStyle: { width: "100%", height: "100%" },
                              attrs: { gutter: 20 },
                            },
                            [
                              _c(
                                "el-col",
                                {
                                  staticStyle: { height: "100%" },
                                  attrs: { span: 4 },
                                },
                                [
                                  _c(
                                    "el-card",
                                    {
                                      staticStyle: {
                                        width: "100%",
                                        height: "100%",
                                        position: "relative",
                                        padding: "0px 10px",
                                      },
                                      attrs: {
                                        "body-style": {
                                          padding: 0,
                                        },
                                      },
                                    },
                                    [
                                      _c("div", {
                                        staticStyle: {
                                          width: "100%",
                                          height: "calc(100%)",
                                          "margin-top": "60px",
                                        },
                                        attrs: { id: "DeviceProgress" },
                                      }),
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            height: "30px",
                                            width: "100%",
                                            position: "absolute",
                                            top: "20px",
                                            left: "0",
                                            "text-align": "center",
                                            "font-weight": "bold",
                                            "font-size": "18px",
                                            "line-height": "30px",
                                          },
                                        },
                                        [
                                          _vm._v(" 提交率"),
                                          _c(
                                            "span",
                                            { staticClass: "hint-text" },
                                            [_vm._v("(乙供+甲供)")]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                {
                                  staticStyle: { height: "100%" },
                                  attrs: { span: 4 },
                                },
                                [
                                  _c(
                                    "el-card",
                                    {
                                      staticStyle: {
                                        width: "100%",
                                        height: "100%",
                                        position: "relative",
                                        padding: "0px 10px",
                                      },
                                      attrs: {
                                        "body-style": {
                                          padding: 0,
                                        },
                                      },
                                    },
                                    [
                                      _c("div", {
                                        staticStyle: {
                                          width: "100%",
                                          height: "calc(100%)",
                                          "margin-top": "60px",
                                        },
                                        attrs: { id: "DocumentProgress" },
                                      }),
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            height: "30px",
                                            width: "100%",
                                            position: "absolute",
                                            top: "20px",
                                            left: "0",
                                            "text-align": "center",
                                            "font-weight": "bold",
                                            "font-size": "18px",
                                            "line-height": "30px",
                                          },
                                        },
                                        [
                                          _vm._v(" 通过率"),
                                          _c(
                                            "span",
                                            { staticClass: "hint-text" },
                                            [_vm._v("(乙供+甲供)")]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                {
                                  staticStyle: { height: "100%" },
                                  attrs: { span: 16 },
                                },
                                [
                                  _c(
                                    "el-card",
                                    {
                                      staticStyle: {
                                        width: "100%",
                                        height: "100%",
                                        position: "relative",
                                        padding: "0px 10px",
                                      },
                                      attrs: {
                                        "body-style": {
                                          padding: 0,
                                        },
                                      },
                                    },
                                    [
                                      _c("div", {
                                        staticStyle: {
                                          width: "100%",
                                          height: "calc(100%)",
                                        },
                                        attrs: { id: "DocumentBar" },
                                      }),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              style: {
                height: _vm.supplierBarHeight + "px",
                width: "100%",
                "margin-top": "10px",
              },
            },
            [
              _c(
                "el-card",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.SupplierCountLoading,
                      expression: "SupplierCountLoading",
                    },
                  ],
                  staticStyle: {
                    height: "100%",
                    width: "100%",
                    position: "relative",
                    padding: "10px",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        height: "30px",
                        position: "absolute",
                        top: "20px",
                        left: "20px",
                        "text-align": "center",
                        "font-weight": "bold",
                        "font-size": "18px",
                        "line-height": "30px",
                      },
                    },
                    [
                      _vm._v(" 供应商提交率/通过率"),
                      _c("span", { staticClass: "hint-text" }, [
                        _vm._v("(乙供+甲供)"),
                      ]),
                    ]
                  ),
                  _c("div", {
                    staticStyle: { width: "100%", height: "calc(100%)" },
                    attrs: { id: "SupplierBar" },
                  }),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("ScheduleView", {
        ref: "ScheduleView",
        on: {
          refresh: () => {
            this.getTableData(1)
            this.getTableData(2)
            this.getTableData(4)
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }